"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var truncateMidString = function (string, maxChars) {
    if (maxChars === void 0) { maxChars = 50; }
    var result = string;
    if (string.length > maxChars) {
        var front = string.substr(0, (maxChars / 2));
        var mid = "...";
        var end = string.substr(-maxChars / 2);
        result = front + mid + end;
    }
    return result;
};
exports.default = truncateMidString;
//# sourceMappingURL=truncate-mid-string.js.map